import React, {Component} from 'react';
import { Link } from 'react-router-dom';
//import { SelectListComponent } from 'shared-components';
import axios from 'axios';
// const querystring = require('querystring');

export default class UserProjects extends Component {

	constructor(props)
	{
		console.log(props);
		super(props);
		
	
		this.state = {
			currentUserProfile : {},
			linkedin : "",
			facebook : "",
			twitter : "",
			instagram : "",
			membershipTypeValue : ""
		};
		this.handleClear = this.handleClear.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}
	componentDidMount() 
	{
		this.handleOnLoad();
	}

	handleOnLoad = () => {
	
		//var m_userId = 227;
		var m_userId = this.props.userId;
		if (m_userId)
		{
			var queryUrl = `${global.config.securityServicesUrl}/user-profile-service/userprofile/${m_userId}`;
			//var queryUrl = `http://convergence.gazelleplatform.com:5100/user-profile-service/userprofile/${m_userId}`;
			axios.get(queryUrl)
		  		.then(response => {
				const currentUserProfileData = response.data; 
				if (currentUserProfileData.socialMediaAccounts === "null")
				{
					
					var sma = {
						linkedin : "",
						facebook : "",
						twitter : "",
						instagram : ""
					}
					currentUserProfileData.socialMediaAccounts = JSON.stringify(sma);
				}

				this.setState({linkedin : JSON.parse(currentUserProfileData.socialMediaAccounts).linkedin});
				this.setState({facebook : JSON.parse(currentUserProfileData.socialMediaAccounts).facebook});
				this.setState({twitter : JSON.parse(currentUserProfileData.socialMediaAccounts).twitter});
				this.setState({instagram : JSON.parse(currentUserProfileData.socialMediaAccounts).instagram});
 				//alert(JSON.stringify(currentUserProfileData.socialMediaAccounts));	
				if (!currentUserProfileData.createUser)
					currentUserProfileData.createUser = m_userId;
				if (!currentUserProfileData.lastUpdateUser)
					currentUserProfileData.lastUpdateUser = m_userId;
				this.setState({currentUserProfile : currentUserProfileData});

// 				alert(this.state.currentUserProfile.membershipType);

				var membershipTypeQueryUrl = `${global.config.apiServicesUrl}/system-code-values/?filter[where][systemCodeValueId][eq]=${this.state.currentUserProfile.membershipType}`;	
				//var membershipTypeQueryUrl = `http://convergence.gazelleplatform.com:3000/system-code-values/?filter[where][systemCodeValueId][eq]=${this.state.currentUserProfile.membershipType}`;	
				console.log(membershipTypeQueryUrl);
				axios.get(membershipTypeQueryUrl)
		  			.then(response => {
		  				console.log(JSON.stringify(response.data));
					this.setState({membershipTypeValue : response.data[0].systemCodeValueValue});
				}).catch(err => {
					console.log(err);
				});	
			});	
		}
		else 
		{
			alert("user id =:> " + this.props.userId);
		}
	}
	handleChange(event){
        console.log(event);
        var target = event.target;
        console.log(target.id + ":" + target.value);
        if (target.id === ("linkedin") || target.id === "twitter" || target.id === "facebook" || target.id === ("instagram"))
        {
        	this.setState({[target.id] : target.value});       	
        }
        else
		{
       	 	this.setState({ currentUserProfile : {...this.state.currentUserProfile, [target.id] : target.value} });	
       	}
   		console.log(this.state);
    }

	handleDelete = (id, event) => {
	}
	handleClear()
	{
		this.state = {


		};
	}
	handleSave = () => {
			
			var queryUrl = `http://convergence.gazelleplatform.com:3000/users`;
			//alert('saving - ' + queryUrl);
			
			if (!this.state.currentUserProfile.lastUpdateUser)
				this.state.currentUserProfile.lastUpdateUser = this.state.currentUserProfile.lastUpdateUser;
			this.state.currentUserProfile.lastUpdateDate = new Date();
			if (!this.state.currentUserProfile.socialMediaAccounts || this.state.currentUserProfile.socialMediaAccounts === "null")
				this.state.currentUserProfile.socialMediaAccounts = "";	
			const m_socialMediaAccounts = {
				"linkedin" : this.state.linkedin,
				"facebook" : this.state.facebook,
				"twitter" : this.state.twitter, 
				"instagram" : this.state.instagram
			}
//			alert(JSON.stringify(m_socialMediaAccounts));
//			this.setState({currentUserProfile : {...this.state.currentUserProfile, [socialMediaAccounts] : JSON.stringify(m_socialMediaAccounts)}});
			this.state.currentUserProfile.socialMediaAccounts = JSON.stringify(m_socialMediaAccounts);
//			alert(JSON.stringify(this.state.currentUserProfile));
			axios.patch(queryUrl, this.state.currentUserProfile)
		  		.then(response => {
					console.log(response.data); 
				}).catch(err => {
				console.log(err);
			});
	
		this.handleOnLoad();
	}
	render(){
	return (
	<form>
	<div class="m-content">
	<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
	<div class="container-fluid">


				<div class="m-grid__item m-grid__item--fluid m-wrapper">

					<div class="m-subheader ">
						<div class="d-flex align-items-center">
							<div class="mr-auto">
								<h3 class="m-subheader__title ">My Profile</h3>
							</div>
							<div>
								<div class="m-dropdown m-dropdown--inline m-dropdown--arrow m-dropdown--align-right m-dropdown--align-push" m-dropdown-toggle="hover" aria-expanded="true">
									<a href="#" class="m-portlet__nav-link btn btn-lg btn-secondary  m-btn m-btn--outline-2x m-btn--air m-btn--icon m-btn--icon-only m-btn--pill  m-dropdown__toggle">
										<i class="la la-plus m--hide"></i>
										<i class="la la-ellipsis-h"></i>
									</a>
									<div class="m-dropdown__wrapper">
										<span class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"></span>
										<div class="m-dropdown__inner">
											<div class="m-dropdown__body">
												<div class="m-dropdown__content">
													<ul class="m-nav">
														<li class="m-nav__section m-nav__section--first m--hide">
															<span class="m-nav__section-text">Quick Actions</span>
														</li>
														<li class="m-nav__item">
															<a href="" class="m-nav__link">
																<i class="m-nav__link-icon flaticon-share"></i>
																<span class="m-nav__link-text">Activity</span>
															</a>
														</li>
														<li class="m-nav__item">
															<a href="" class="m-nav__link">
																<i class="m-nav__link-icon flaticon-chat-1"></i>
																<span class="m-nav__link-text">Messages</span>
															</a>
														</li>
														<li class="m-nav__item">
															<a href="" class="m-nav__link">
																<i class="m-nav__link-icon flaticon-info"></i>
																<span class="m-nav__link-text">FAQ</span>
															</a>
														</li>
														<li class="m-nav__item">
															<a href="" class="m-nav__link">
																<i class="m-nav__link-icon flaticon-lifebuoy"></i>
																<span class="m-nav__link-text">Support</span>
															</a>
														</li>
														<li class="m-nav__separator m-nav__separator--fit">
														</li>
														<li class="m-nav__item">
															<a href="#" class="btn btn-outline-danger m-btn m-btn--pill m-btn--wide btn-sm">Submit</a>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="m-content">
						<div class="row">
							<div class="col-xl-3 col-lg-4">
								<div class="m-portlet m-portlet--full-height  ">
									<div class="m-portlet__body">
										<div class="m-card-profile">
											<div class="m-card-profile__title m--hide">
												Your Profile
											</div>
											<div class="m-card-profile__pic">
												<div class="m-card-profile__pic-wrapper">
													<img src={this.state.currentUserProfile.pictureFilepath} alt="" />
												</div>
											</div>
											<div class="m-card-profile__details">
												<span class="m-card-profile__name">{this.state.currentUserProfile.firstName} {this.state.currentUserProfile.lastName}</span>
												<a href="" class="m-card-profile__email m-link">{this.state.currentUserProfile.email}</a>
											</div>
										</div>
										<ul class="m-nav m-nav--hover-bg m-portlet-fit--sides">
											<li class="m-nav__separator m-nav__separator--fit"></li>
											<li class="m-nav__section m--hide">
												<span class="m-nav__section-text">Section</span>
											</li>
											<li class="m-nav__item">
												<a href="header/profile&amp;demo=default.html" class="m-nav__link">
													<i class="m-nav__link-icon flaticon-profile-1"></i>
													<span class="m-nav__link-title">
														<span class="m-nav__link-wrap">
															<span class="m-nav__link-text">My Profile</span>
															<span class="m-nav__link-badge"><span class="m-badge m-badge--success">2</span></span>
														</span>
													</span>
												</a>
											</li>
											<li class="m-nav__item">
												<a href="header/profile&amp;demo=default.html" class="m-nav__link">
													<i class="m-nav__link-icon flaticon-share"></i>
													<span class="m-nav__link-text">Activity</span>
												</a>
											</li>
											<li class="m-nav__item">
												<a href="header/profile&amp;demo=default.html" class="m-nav__link">
													<i class="m-nav__link-icon flaticon-chat-1"></i>
													<span class="m-nav__link-text">Messages</span>
												</a>
											</li>
											<li class="m-nav__item">
												<a href="header/profile&amp;demo=default.html" class="m-nav__link">
													<i class="m-nav__link-icon flaticon-graphic-2"></i>
													<span class="m-nav__link-text">Sales</span>
												</a>
											</li>
											<li class="m-nav__item">
												<a href="header/profile&amp;demo=default.html" class="m-nav__link">
													<i class="m-nav__link-icon flaticon-time-3"></i>
													<span class="m-nav__link-text">Events</span>
												</a>
											</li>
											<li class="m-nav__item">
												<a href="header/profile&amp;demo=default.html" class="m-nav__link">
													<i class="m-nav__link-icon flaticon-lifebuoy"></i>
													<span class="m-nav__link-text">Support</span>
												</a>
											</li>
										</ul>
										<div class="m-portlet__body-separator"></div>
										<div class="m-widget1 m-widget1--paddingless">
											<div class="m-widget1__item">
												<div class="row m-row--no-padding align-items-center">
													<div class="col">
														<h3 class="m-widget1__title">Member Profit</h3>
														<span class="m-widget1__desc">Awerage Weekly Profit</span>
													</div>
													<div class="col m--align-right">
														<span class="m-widget1__number m--font-brand">${0.00}</span>
													</div>
												</div>
											</div>
											<div class="m-widget1__item">
												<div class="row m-row--no-padding align-items-center">
													<div class="col">
														<h3 class="m-widget1__title">Orders</h3>
														<span class="m-widget1__desc">Weekly Customer Orders</span>
													</div>
													<div class="col m--align-right">
														<span class="m-widget1__number m--font-danger">${0.00}</span>
													</div>
												</div>
											</div>
											<div class="m-widget1__item">
												<div class="row m-row--no-padding align-items-center">
													<div class="col">
														<h3 class="m-widget1__title">Issue Reports</h3>
														<span class="m-widget1__desc">System bugs and issues</span>
													</div>
													<div class="col m--align-right">
														<span class="m-widget1__number m--font-success">{0.00}%</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-xl-9 col-lg-8">
								<div class="m-portlet m-portlet--full-height m-portlet--tabs  ">
									<div class="m-portlet__head">
										<div class="m-portlet__head-tools">
											<ul class="nav nav-tabs m-tabs m-tabs-line   m-tabs-line--left m-tabs-line--primary" role="tablist">
												<li class="nav-item m-tabs__item">
													<a class="nav-link m-tabs__link active" data-toggle="tab" href="#m_user_profile_tab_1" role="tab">
														<i class="flaticon-share m--hide"></i>
														Update Profile
													</a>
												</li>
												<li class="nav-item m-tabs__item">
													<a class="nav-link m-tabs__link" data-toggle="tab" href="#m_user_profile_tab_2" role="tab">
														Messages
													</a>
												</li>
												<li class="nav-item m-tabs__item">
													<a class="nav-link m-tabs__link" data-toggle="tab" href="#m_user_profile_tab_3" role="tab">
														Settings
													</a>
												</li>
											</ul>
										</div>
										<div class="m-portlet__head-tools">
											<ul class="m-portlet__nav">
												<li class="m-portlet__nav-item m-portlet__nav-item--last">
													<div class="m-dropdown m-dropdown--inline m-dropdown--arrow m-dropdown--align-right m-dropdown--align-push" m-dropdown-toggle="hover" aria-expanded="true">
														<a href="#" class="m-portlet__nav-link btn btn-lg btn-secondary  m-btn m-btn--icon m-btn--icon-only m-btn--pill  m-dropdown__toggle">
															<i class="la la-gear"></i>
														</a>
														<div class="m-dropdown__wrapper">
															<span class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"></span>
															<div class="m-dropdown__inner">
																<div class="m-dropdown__body">
																	<div class="m-dropdown__content">
																		<ul class="m-nav">
																			<li class="m-nav__section m-nav__section--first">
																				<span class="m-nav__section-text">Quick Actions</span>
																			</li>
																			<li class="m-nav__item">
																				<a href="" class="m-nav__link">
																					<i class="m-nav__link-icon flaticon-share"></i>
																					<span class="m-nav__link-text">Create Post</span>
																				</a>
																			</li>
																			<li class="m-nav__item">
																				<a href="" class="m-nav__link">
																					<i class="m-nav__link-icon flaticon-chat-1"></i>
																					<span class="m-nav__link-text">Send Messages</span>
																				</a>
																			</li>
																			<li class="m-nav__item">
																				<a href="" class="m-nav__link">
																					<i class="m-nav__link-icon flaticon-multimedia-2"></i>
																					<span class="m-nav__link-text">Upload File</span>
																				</a>
																			</li>
																			<li class="m-nav__section">
																				<span class="m-nav__section-text">Useful Links</span>
																			</li>
																			<li class="m-nav__item">
																				<a href="" class="m-nav__link">
																					<i class="m-nav__link-icon flaticon-info"></i>
																					<span class="m-nav__link-text">FAQ</span>
																				</a>
																			</li>
																			<li class="m-nav__item">
																				<a href="" class="m-nav__link">
																					<i class="m-nav__link-icon flaticon-lifebuoy"></i>
																					<span class="m-nav__link-text">Support</span>
																				</a>
																			</li>
																			<li class="m-nav__separator m-nav__separator--fit m--hide">
																			</li>
																			<li class="m-nav__item m--hide">
																				<a href="#" class="btn btn-outline-danger m-btn m-btn--pill m-btn--wide btn-sm">Submit</a>
																			</li>
																		</ul>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</li>
											</ul>
										</div>
									</div>
									<div class="tab-content">
										<div class="tab-pane active" id="m_user_profile_tab_1">
											<form class="m-form m-form--fit m-form--label-align-right">
												<div class="m-portlet__body">
													<div class="form-group m-form__group m--margin-top-10 m--hide">
														<div class="alert m-alert m-alert--default" role="alert">
															The example form below demonstrates common HTML form elements that receive updated styles from Bootstrap with additional classes.
														</div>
													</div>
													<div class="form-group m-form__group row">
														<div class="col-10 ml-auto">
															<h3 class="m-form__section">1. Personal Details</h3>
														</div>
													</div>
													<div class="form-group m-form__group row">
														<label for="example-text-input" class="col-2 col-form-label">Username</label>
														<div class="col-7">
															<input class="form-control m-input" type="text" onChange={this.handleChange} 
															id="username"
															value={this.state.currentUserProfile.username} ></input>
														</div>
													</div>
													<div class="form-group m-form__group row">
														<label for="example-text-input" class="col-2 col-form-label">First Name</label>
														<div class="col-7">
															<input class="form-control m-input" type="text" onChange={this.handleChange}
															id="firstName" value={this.state.currentUserProfile.firstName} ></input>
														</div>
													</div>
													<div class="form-group m-form__group row">
														<label for="example-text-input" class="col-2 col-form-label">Last Name</label>
														<div class="col-7">
															<input class="form-control m-input" type="text" onChange={this.handleChange}
															id="lastName" value={this.state.currentUserProfile.lastName} ></input>
														</div>
													</div>
													<div class="form-group m-form__group row">
														<label for="example-text-input" class="col-2 col-form-label">Occupation/Description</label>
														<div class="col-7">
															<input class="form-control m-input" type="text" onChange={this.handleChange}
															id="userDescr" value={this.state.currentUserProfile.userDescr}></input>
														</div>
													</div>
													<div class="form-group m-form__group row">
														<label for="example-text-input" class="col-2 col-form-label">Company Name</label>
														<div class="col-7">
															<input class="form-control m-input" type="text" onChange={this.handleChange}
															id="userCompanyName" value={this.state.currentUserProfile.userCompanyName}></input>
														</div>
													</div>
													<div class="form-group m-form__group row">
														<label for="example-text-input" class="col-2 col-form-label">Phone No.</label>
														<div class="col-7">
															<input class="form-control m-input" type="text" onChange={this.handleChange}
															id="mobilePhone" value={this.state.currentUserProfile.mobilePhone}></input>
														</div>
													</div>
													<div class="m-form__seperator m-form__seperator--dashed m-form__seperator--space-2x"></div>
													<div class="form-group m-form__group row">
														<div class="col-10 ml-auto">
															<h3 class="m-form__section">2. Address</h3>
														</div>
													</div>
													<div class="form-group m-form__group row">
														<label for="example-text-input" class="col-2 col-form-label">Address</label>
														<div class="col-7">
															<input class="form-control m-input" type="text" onChange={this.handleChange}
															id="userAddress" value={this.state.currentUserProfile.userAddress}></input>
														</div>
													</div>
													<div class="form-group m-form__group row">
														<label for="example-text-input" class="col-2 col-form-label">Apt/Suite</label>
														<div class="col-7">
															<input class="form-control m-input" type="text" onChange={this.handleChange}
															id="userSuite" value={this.state.currentUserProfile.userSuite}></input>
														</div>
													</div>
													<div class="form-group m-form__group row">
														<label for="example-text-input" class="col-2 col-form-label">City</label>
														<div class="col-7">
															<input class="form-control m-input" type="text" onChange={this.handleChange}
															id="userCity" value={this.state.currentUserProfile.userCity}></input>
														</div>
													</div>
													<div class="form-group m-form__group row">
														<label for="example-text-input" class="col-2 col-form-label">State</label>
														<div class="col-7">
															<input class="form-control m-input" type="text" onChange={this.handleChange}
															id="userState" value={this.state.currentUserProfile.userState}></input>
														</div>
													</div>
													<div class="form-group m-form__group row">
														<label for="example-text-input" class="col-2 col-form-label">Postal Code</label>
														<div class="col-7">
															<input class="form-control m-input" type="text" onChange={this.handleChange}
															id="userPostalCode" value={this.state.currentUserProfile.userPostalCode}></input>
														</div>
													</div>
													<div class="m-form__seperator m-form__seperator--dashed m-form__seperator--space-2x"></div>
													<div class="form-group m-form__group row">
														<div class="col-10 ml-auto">
															<h3 class="m-form__section">3. Social Links</h3>
														</div>
													</div>
													<div class="form-group m-form__group row">
														<label for="example-text-input" class="col-2 col-form-label">Linkedin</label>
														<div class="col-7">
															<input class="form-control m-input" type="text" onChange={this.handleChange}
															id="linkedin" value={this.state.linkedin}></input>
														</div>
													</div>
													<div class="form-group m-form__group row">
														<label for="example-text-input" class="col-2 col-form-label">Facebook</label>
														<div class="col-7">
															<input class="form-control m-input" type="text" onChange={this.handleChange}
															id="facebook" value={this.state.facebook}></input>
														</div>
													</div>
													<div class="form-group m-form__group row">
														<label for="example-text-input" class="col-2 col-form-label">Twitter</label>
														<div class="col-7">
															<input class="form-control m-input" type="text" onChange={this.handleChange}
															id="twitter" value={this.state.twitter}></input>
														</div>
													</div>
													<div class="form-group m-form__group row">
														<label for="example-text-input" class="col-2 col-form-label">Instagram</label>
														<div class="col-7">
															<input class="form-control m-input" type="text" onChange={this.handleChange}
															id="instagram" value={this.state.instagram} ></input>
														</div>
													</div>												
													<div class="m-form__seperator m-form__seperator--dashed m-form__seperator--space-2x"></div>
													<div class="form-group m-form__group row">
														<div class="col-10 ml-auto">
															<h3 class="m-form__section">4. Settings</h3>
														</div>
													</div>
													<div class="form-group m-form__group row">
														<label for="example-text-input" class="col-2 col-form-label">Subscription Level</label>
														<div class="col-7">
															<input class="form-control m-input" type="text" onChange={this.handleChange}
															id="membershipType" value={this.state.membershipTypeValue}></input>
														</div>
													</div>
												</div>
												<div class="m-portlet__foot m-portlet__foot--fit">
													<div class="m-form__actions">
														<div class="row">
															<div class="col-2">
															</div>
															<div class="col-7">
																<button type="reset" class="btn btn-accent m-btn m-btn--air m-btn--custom" onClick={this.handleSave}>Save changes</button>&nbsp;&nbsp;
																<button type="reset" class="btn btn-secondary m-btn m-btn--air m-btn--custom">Cancel</button>
															</div>
														</div>
													</div>
												</div>
											
											</form>
										
										</div>
										</div>
										<div class="tab-pane " id="m_user_profile_tab_2">
										</div>
										<div class="tab-pane " id="m_user_profile_tab_3">
										</div>
									</div>
									
									
									
								</div>
							</div>
						</div>
					</div>

	</div>
	</div>
	</div>
	</form>
);


}
}

